
export { useCookie } from "/home/jenkins/agent/workspace/web-sunrise-prod/web-sunrise-business-deploy-prod/libs/shared/hooks/src/lib/useCookie.ts"